import CidadeController from "@/shared/controllers/cidade/cidadeController";
import EstadoController from "@/shared/controllers/estado/estadoController";
import AccountLoged from "@/shared/mixins/AccountLoged";

import { defineComponent } from "vue";

const name = 'GerenciamentoCidades'

export default defineComponent({
  name,

  components: { },

  props: { },
  mixins:[AccountLoged],

  mounted () {
    if(!this.hasClaim('Gerenciamento-Cidades')) {
      this.$router.push('/sem-acesso')
    }
    this.EstadosArray = EstadoController.getEstados().EstadosArray;
  },

  updated () { },

  data () {
    return {
      EstadosArray: [],
      CidadeArray: [],
      indexEdicao: -1,
      estadoSelecionadoId: '',
      cidadeSelecionadaId: '',
      cidadesTipoFrete: [],
      popupEdicao: false,
      cidadeSelecionadaEdicao: {},
      Colunas : [
        {field: 'nomeCidade', header: 'Cidade', ordena: false},
        {field: 'estado', header: 'Estado', ordena: false},
        {field: 'fracionado', header: 'Fracionado'},
        {field: 'fechado', header: 'Fechado'},
      ],


    }
  },

  methods: {

    getCidades(e){
      CidadeController.getByCidadeEstado(e, this.estadoSelecionadoId).requisicao
      .then(res => {
        this.CidadeArray = res.data.data
      })
    },

    limpar(){
      this.estadoSelecionadoId = '';
      this.cidadeSelecionadaId = '';
    },

    buscaCidades(){
      this.$isLoading(true)
      CidadeController.GetCidadeTipoFrete(this.estadoSelecionadoId, this.cidadeSelecionadaId?.id).requisicao
      .then(res => {
        this.cidadesTipoFrete = res.data.data
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },
    abrirPopupEdicao(cidade, index){
      this.indexEdicao = index;
      this.cidadeSelecionadaEdicao = cidade;
      this.popupEdicao = true;
    },

    retornaSimENao(valor){
      return valor ? 'SIM' : 'NÃO'
    },

    atualizarCidade(){
      const cidadeId = this.cidadeSelecionadaEdicao.cidadeId;
      const ehFechado = this.cidadeSelecionadaEdicao.ehFechado;
      const ehFracionado = this.cidadeSelecionadaEdicao.ehFracionado;
      CidadeController.AtualizaTipoFreteCidade(cidadeId, ehFechado, ehFracionado).requisicao
      .then(res => {
        let tipoToast = "error"
        let tituloToast = "Erro ao atualizar as informações"
        let detalhesToast = "Ocorreu um erro ao atualizar as informações"

        if(res.data.data){
          tipoToast = "success"
          tituloToast = "Informações atualizadas com sucesso!"
          detalhesToast = "As informações da cidade foram atualizadas com sucesso"
        }

        this.$toast.add({ severity: tipoToast, summary: tituloToast, detail: detalhesToast, life: 3000 })
        this.popupEdicao = false;


        this.cidadesTipoFrete[this.indexEdicao].fechado = this.retornaSimENao(ehFechado);
        this.cidadesTipoFrete[this.indexEdicao].fracionado = this.retornaSimENao(ehFracionado);

        this.cidadesTipoFrete[this.indexEdicao].ehFechado = this.retornaSimENao(ehFechado) === 'SIM' ;
        this.cidadesTipoFrete[this.indexEdicao].ehFracionado = this.retornaSimENao(ehFracionado) === 'SIM' ;
      })
    },

    fecharPopup(){
      this.popupEdicao = false
    }
  },

  computed: { },

});